import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Firebase App Check (#79) — gated on NEXT_PUBLIC_APP_CHECK_SITE_KEY so the
// rollout is decoupled from this code shipping. Enforcement is flipped on
// per-service in Firebase Console; until then tokens are generated but not
// required.
//
// IMPORTANT: We must pre-load enterprise.js with `?render=${siteKey}` BEFORE
// initializeAppCheck runs. Firebase Auth + App Check both consume the global
// `grecaptcha.enterprise`, but they load the script differently:
//   - App Check: enterprise.js (no params) + programmatic render(div, {sitekey})
//   - Firebase Auth: enterprise.js?render=KEY + direct execute(KEY)
// If App Check loads first, Firebase Auth's loader sees grecaptcha.enterprise
// already exists, skips its own load, and calls execute(KEY) against a
// registry that was never populated with KEY — throwing
// "Invalid site key or not loaded in api.js: <KEY>" and breaking sign-in.
// Pre-loading with ?render=KEY ourselves registers the key globally so both
// products work.
if (typeof window !== "undefined") {
  const appCheckSiteKey = process.env.NEXT_PUBLIC_APP_CHECK_SITE_KEY;
  if (appCheckSiteKey) {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${appCheckSiteKey}`;
    script.async = true;
    script.onload = () => {
      try {
        initializeAppCheck(app, {
          provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
          isTokenAutoRefreshEnabled: true,
        });
      } catch (err) {
        console.error("[app-check] init failed", err);
      }
    };
    script.onerror = (err) => {
      console.error("[app-check] enterprise.js preload failed", err);
    };
    document.head.appendChild(script);
  }
}

export const auth = getAuth(app);
export const db = getFirestore(app);
